import React, { useEffect, useRef } from "react";

/**
 * AdSense Ad Component
 * Place this component where you want ads to appear.
 * Make sure the AdSense script is loaded in index.html.
 */
const AdSenseAd = ({ adSlot, adFormat = "auto", fullWidthResponsive = true }) => {
  const adRef = useRef(null);

  useEffect(() => {
    let mounted = true;
    
    // Use requestAnimationFrame to avoid blocking the main thread
    const loadAd = () => {
      requestAnimationFrame(() => {
        if (!mounted) return;
        
        try {
          // Check if container has width before pushing ad
          if (adRef.current && adRef.current.offsetWidth > 0) {
            if (window.adsbygoogle && process.env.NODE_ENV === "production") {
              (window.adsbygoogle = window.adsbygoogle || []).push({});
            }
          }
        } catch (err) {
          console.error("AdSense error:", err);
        }
      });
    };

    // Small delay to ensure container is sized, but use RAF to be non-blocking
    const timer = setTimeout(loadAd, 150);

    return () => {
      mounted = false;
      clearTimeout(timer);
    };
  }, []);

  // Only show ads in production
  if (process.env.NODE_ENV !== "production") {
    return (
      <div className="bg-gray-200 dark:bg-gray-700 text-gray-600 dark:text-gray-400 text-center py-8 px-4 rounded my-4">
        <p className="text-sm">📢 Ad Placeholder (dev mode)</p>
        <p className="text-xs mt-2">Slot ID: {adSlot}</p>
      </div>
    );
  }

  return (
    <div ref={adRef} className="my-8 flex justify-center min-h-[100px]">
      <ins
        className="adsbygoogle"
        style={{ 
          display: "block", 
          minWidth: "300px",
          minHeight: "100px"
        }}
        data-ad-client="ca-pub-9720118361195872"
        data-ad-slot={adSlot}
        data-ad-format={adFormat}
        data-full-width-responsive={fullWidthResponsive.toString()}
      ></ins>
    </div>
  );
};

export default AdSenseAd;
